import { useTranslation } from 'react-i18next';
import { user } from 'services';
import { Table } from 'libs/ui';
import { SortContext } from 'libs/control';

export const TableExt = (props) => {
  const { withComment, comments, refresh, getFields, ...rest } = props;

  const { t } = useTranslation();

  const changeActions = (actions) => {
    if (!actions) {
      return actions;
    }
    const out = actions.slice();
    if (withComment) {
      if (user.haveRight('comment.add')) {
        out.push({ title: t('grid.Оставить комментарий'), action: 'add-comment' });
      }
      // if (user.haveRight('comment.list')) {
      out.push({
        title: t('grid.Посмотреть комментарии'),
        action: 'show-comments',
        isVisible: (row) => row.comments && row.comments.length,
      });
      // }
    }
    return out;
  };

  const actions = changeActions(props.actions);

  if (getFields) {
    rest.fields = getFields(props);
  }

  return <SortContext.Consumer>{({ refreshed }) => <Table {...rest} actions={actions} refreshed={refreshed} refresh={refresh} />}</SortContext.Consumer>;
};
